import { render, staticRenderFns } from "./navpanel.vue?vue&type=template&id=5c7f5b6c"
import script from "./navpanel.vue?vue&type=script&lang=js"
export * from "./navpanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports